function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import styles from './styles.scss';
var LinkButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var href = _ref.href,
      children = _ref.children,
      variant = _ref.variant,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["href", "children", "variant", "className"]);

  var classNames = [styles.btn, styles[variant], className];
  return /*#__PURE__*/React.createElement("a", Object.assign({
    ref: ref,
    href: href,
    className: classNames.join(' ')
  }, otherProps), children);
});
LinkButton.defaultProps = {
  variant: 'default',
  className: null
};
export default LinkButton;